import { usePagination } from '@fourthwall/components'

import type { GiftCard } from '../GiftCards.types'
import { useFilterGiftCards } from '../modules/GiftCardsFilter'
import { useGiftCardsQuery } from '../queries/useGiftCardsQuery'

export const useGiftCards = () => {
  const { filtersParams } = useFilterGiftCards()
  const [currentPage] = usePagination()
  const { giftCardsQuery } = useGiftCardsQuery(
    [
      {
        page: currentPage - 1,
        size: 20,
        // @ts-ignore
        status: filtersParams.status as GiftCard['status'][] | undefined,
      },
    ],
    {
      keepPreviousData: true,
    },
  )

  return {
    data: giftCardsQuery.data?.result || [],
    isLoading: giftCardsQuery.isFetching,
    totalPages: giftCardsQuery.data?.page.totalPages || 0,
  }
}
